<template>
  <label
    :class="['container', 'select', 'focusable', `s-${index}`]"
    :for="`checkbox-sentence-${index}`"
    @keyup.enter="handleOnKeyboardEnter"
    tabindex="0"
  >
    <input :id="`checkbox-sentence-${index}`" name="checkbox-sentence" type="radio" tabindex="-1" />
    <span :class="getValidationClass(isChecked, hasError)"></span>
    <div :aria-live="isChecked && !hasError ? 'polite' : 'off'" class="step" role="region">
      {{ value }}
    </div>
  </label>
</template>

<script>
export default {
  props: ['hasError', 'index', 'isChecked', 'value', 'handleOnKeyboardEnter'],
  methods: {
    getValidationClass(isChecked, hasError) {
      const className = ['checkmark'];

      if (isChecked) {
        className.push('is-checked');
      }

      if (hasError) {
        className.push('has-error');
      }

      return className.join(' ');
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  cursor: pointer;
  display: block;
  margin-bottom: 12px;
  padding-left: 40px;
  position: relative;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}

.container input {
  cursor: pointer;
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;
}

.checkmark {
  border: 2px solid gray;
  border-radius: 50%;
  height: 30px;
  left: 0;
  position: absolute;
  top: 0;
  width: 30px;
}

.container:hover input ~ .checkmark {
  background-color: white;
}

.container:hover input ~ .checkmark:after {
  background-color: lighten(black, 35%);
}

.container input ~ .checkmark.is-checked:after {
  background-color: limegreen;
}

.container input ~ .checkmark.has-error.is-checked:after {
  background-color: red;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: '';
  background-color: lighten(gray, 35%);
  border: 2px solid gray;
  border-radius: 50%;
  height: 50%;
  left: 50%;
  position: absolute;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: 0.2s;
  transition-property: background-color;
  width: 50%;
}

.container input:checked ~ .checkmark:after {
  display: block;
}

.select {
  margin: 2.75% 0;

  .step {
    display: inline-block;
    height: 35px;
    line-height: 35px;
    vertical-align: top;
  }
}
</style>
